<template>
    <div>
        <footer class="main-footer">
            <div class="row">
                <div class="col-sm-12 d-flex align-items-center justify-content-xl-start justify-content-lg-start justify-content-md-start justify-content-center">
                    <p class="text-gradient-02">Copyright {{ workspace.workspace_name }} 2019 &bull; Application Development by Switchstance &bull; <small>Version {{ this.appVersionNumber }}</small></p>
                </div>
                <div class="col-sm-12 d-flex align-items-center justify-content-xl-end justify-content-lg-end justify-content-md-end justify-content-center">
                    <!--<ul class="nav">
                        <li class="nav-item">
                            <a class="nav-link" href="documentation.html">Documentation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="changelog.html">Changelog</a>
                        </li>
                    </ul>-->
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        props: ['workspace'],
    }
</script>